<div class="newsletter-resignation-info">
  <div class="container">
    @if (!isSuccess) {
      <div class="newsletter-resignation-info__content">
        <div class="newsletter-resignation-info__failed">{{ errors }}</div>
      </div>
    }
    @if (isSuccess) {
      <div class="newsletter-resignation-info__content">
        <div class="newsletter-resignation-info__success">{{ "NEWSLETTER_RESIGNATION_INFO.SUCCESS" | translate }}</div>
      </div>
    }
  </div>
</div>

<app-footer></app-footer>
